var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0856 2.91379L13.0862 6.91442L4.39904 15.6016L0.832161 15.9954C0.354661 16.0482 -0.0487768 15.6444 0.00434818 15.1669L0.401223 11.5975L9.0856 2.91379ZM15.5606 2.31817L13.6822 0.439728C13.0962 -0.14621 12.1459 -0.14621 11.56 0.439728L9.79279 2.20692L13.7934 6.20754L15.5606 4.44035C16.1465 3.8541 16.1465 2.9041 15.5606 2.31817Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.ed3b8d97bad928f524eb8c30407133a8.svg";
export { ForwardRef as ReactComponent };